import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/BaseConditions/PropertyTag.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
export var BubbleText = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  font-size: 13px;\n  word-break: break-word;\n  padding: 3px 0 3px 8px;\n  line-height: 19px;\n\n  ", "\n"])), function (props) {
  return props.error ? '#D9575E' : '#00003d';
}, function (props) {
  return props.readonly && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      padding: 3px 8px;\n    "])));
});
export var Bubble = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  background: ", ";\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n  cursor: default;\n\n  & path {\n    transition: stroke 0.2s ease-out;\n    stroke: ", ";\n  }\n\n  &:hover path {\n    stroke: ", ";\n  }\n"])), function (props) {
  return props.error ? 'rgba(217, 87, 94, 0.2)' : 'rgba(0, 0, 61, 0.1)';
}, function (props) {
  return props.error ? 'rgba(217, 87, 94, 0.5)' : 'rgba(0, 0, 61, 0.5)';
}, function (props) {
  return props.error ? 'rgba(217, 87, 94, 0.75)' : 'rgba(0, 0, 61, 0.75)';
});
export var DeleteButton = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  border-radius: 0 4px 4px 0;\n  transition: background-color ease-out 0.2s;\n  cursor: pointer;\n\n  &:hover {\n    background: ", ";\n\n    &:hover path {\n      stroke: ", ";\n    }\n  }\n"])), function (props) {
  return props.error ? 'rgba(217, 87, 94, 0.1)' : 'rgba(0, 0, 61, 0.1)';
}, function (props) {
  return props.error ? 'rgba(217, 87, 94, 1)' : 'rgba(0, 0, 61, 1)';
});
export var CrossWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 18px;\n  min-width: 18px;\n  height: 18px;\n  min-height: 18px;\n"])));